module.exports = __webpack_public_path__ + "img/chccs-logo-dark.fb739369.svg";